import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaShieldAlt, FaStar, FaChartLine, FaHeadset } from "react-icons/fa";
import "../sell-fast-page/info-page.css";

const BENEFITS = [
  {
    icon: <FaShieldAlt size={22} color="#ed1b24" />,
    title: "Verified Seller Badge",
    desc: "Get a trusted blue verified badge on your profile and all your listings. Buyers prefer verified sellers — it builds instant credibility.",
  },
  {
    icon: <FaStar size={22} color="#ed1b24" />,
    title: "Priority Listing Placement",
    desc: "Your ads are placed higher in search results, giving them more visibility over standard listings without needing to boost individually.",
  },
  {
    icon: <FaChartLine size={22} color="#ed1b24" />,
    title: "More Listings",
    desc: "Post more active listings simultaneously. Ideal for dealers and frequent sellers who always have multiple vehicles available.",
  },
  {
    icon: <FaHeadset size={22} color="#ed1b24" />,
    title: "Priority Support",
    desc: "Skip the queue. Verified members receive faster responses from our support team for any queries or listing issues.",
  },
];

function MembershipPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          <div className="info-page__hero">
            <p className="info-page__eyebrow">For Sellers</p>
            <h1 className="info-page__title">AdsOne Verified Membership</h1>
            <p className="info-page__subtitle">
              Stand out from the crowd. A verified membership gives your listings more trust, more visibility and more enquiries.
            </p>
          </div>

          <div className="info-page__body">
            <div className="row g-3">
              {BENEFITS.map((b, i) => (
                <div key={i} className="col-sm-12 col-md-6">
                  <div className="info-section" style={{ height: "100%" }}>
                    <div className="info-section__icon-wrap">{b.icon}</div>
                    <div className="info-section__content">
                      <h3 className="info-section__title">{b.title}</h3>
                      <p style={{ fontSize: "0.9rem", color: "#475569", margin: 0, lineHeight: 1.6 }}>{b.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="info-section" style={{ flexDirection: "column", gap: "0.5rem", background: "#fafafa" }}>
              <h3 className="info-section__title">How to Get Verified</h3>
              <ul className="info-section__list">
                {[
                  "Register for a free seller account on AdsOne.lk.",
                  "Post at least one vehicle listing and ensure your profile is complete.",
                  "Contact our team at info@adsone.lk with your account email to request verification.",
                  "Our team will review your account and activate your verified badge within 24 hours.",
                ].map((p, i) => (
                  <li key={i}>
                    <FaCheckCircle size={13} color="#22c55e" style={{ flexShrink: 0, marginTop: 2 }} />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="info-page__cta">
            <h3>Ready to get verified?</h3>
            <p>Create your free seller account and start reaching thousands of buyers across Sri Lanka.</p>
            <Link to="/registration" className="btn px-5 py-2 fw-bold" style={{ borderRadius: "50rem" }}>
              Register Free
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default MembershipPage;
